import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const AppUserModalStyles: moduleStyleType = {
    content: {
        marginTop: 3,
    },
}
